import styled from 'styled-components/macro'

export const StyledCircleButton = styled.button`
    border-radius: 50%;
    border: 1px solid #eee;
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    background: #fff;
    box-shadow: #666 0 0 5px;

    outline: none;

    &:hover, &:focus {
        background: #eee;
    }
    &:active {
        transform: scale(0.9);
    }
`